import callApi from '@/utils/callApi';
import batchFunction from '@/utils/batchFunction';

// @TODO also memoize? :D
export default batchFunction(async function (ids) {
  const res = await callApi('GET', '/v2/top-reviews/' + ids.join(','));
  const highlights = await res.json();
  return highlights;
}, 1);
